import { render, staticRenderFns } from "./AnnymtyPage.vue?vue&type=template&id=7af72c92&scoped=true&"
import script from "./AnnymtyPage.vue?vue&type=script&lang=js&"
export * from "./AnnymtyPage.vue?vue&type=script&lang=js&"
import style0 from "./AnnymtyPage.vue?vue&type=style&index=0&id=7af72c92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af72c92",
  null
  
)

export default component.exports